"use client";

import { type Transition, useReducedMotion } from "motion/react";

export const SPRING: Transition = {
  bounce: 0,
  duration: 0.35,
  type: "spring",
};

export const SPRING_FAST: Transition = {
  bounce: 0,
  duration: 0.3,
  type: "spring",
};

export const SPRING_SLOW: Transition = {
  bounce: 0,
  duration: 0.6,
  type: "spring",
};

export function useMotionSafe() {
  const reduced = useReducedMotion();
  return <T>(value: T): T | undefined => (reduced ? undefined : value);
}
